






















import { FormModalParams, FormModalSizeEnum } from '@/components/global/modal/form-modal-models';
import OtFormModal from '@/components/global/modal/ot-form-modal.vue';
import OtApi, { executeApi } from '@/services/api.service';
import { PostUpdateDocumentAssociationsRequestModel } from '@/services/generated/api';
import { IVForm } from '@/utils/type-utils';
import { Component, Ref, Vue } from 'vue-property-decorator';
import {
  CreateDocumentAssociationsDialogParams,
  CreateDocumentAssociationsDialogResult,
} from './create-document-associations-models';
import OtCreateDocumentAssociations from './ot-create-document-associations.vue';

@Component({
  components: {
    OtFormModal,
    OtCreateDocumentAssociations,
  },
})
export default class OtCreateDocumentAssociationsDialog extends Vue {
  @Ref('formModalRef') private readonly formModalRef!: OtFormModal;
  @Ref('modalContentRef') private readonly modalContentRef!: IVForm;
  @Ref('createDocumentAssociationsRef') private readonly createDocumentAssociationsRef?: OtCreateDocumentAssociations;

  private params: CreateDocumentAssociationsDialogParams | null = null;
  private api = new OtApi();

  private async initialise(params: CreateDocumentAssociationsDialogParams) {
    this.params = params;
    // Initialize your form data here
    await this.$nextTick();
    this.createDocumentAssociationsRef?.reset();
  }

  public async validate() {
    await this.$nextTick();
    if (this.createDocumentAssociationsRef) {
      return this.createDocumentAssociationsRef.validate();
    }
    return true; // Implement your validation logic here
  }

  public async open(params: CreateDocumentAssociationsDialogParams): Promise<CreateDocumentAssociationsDialogResult> {
    await this.initialise(params);

    const baseParams = new FormModalParams({
      title: 'Create Document Associations',
      formRef: this.modalContentRef,
      confirmText: 'Create Associations',
      cancelText: 'Cancel',
      size: FormModalSizeEnum.Large,
      onValidate: this.validate,
      onAfterFormMounted: () => this.initialise(params),
      onBeforeConfirmClose: async () => {
        const associations = this.createDocumentAssociationsRef
          ? await this.createDocumentAssociationsRef.submit()
          : null;
        const documentGid = params.documentGid;
        if (associations && documentGid) {
          const request = new PostUpdateDocumentAssociationsRequestModel({
            addContractAssociations: associations.addToContractGids,
            addOrganisationAssociations: associations.addToOrganisation ? [params.targetOrganisationGid] : [],
            addProjectAssociations: associations.addToProjectGids,
            removeContractAssociations: [],
            removeOrganisationAssociations: [],
            removeProjectAssociations: [],
          });
          const result = await executeApi(
            () => this.api.documents().postUpdateDocumentAssociations(documentGid, request),
            'Update Document Associations',
          );
          if (result.success) {
            return true;
          }
        }
        return false;
      },
    });

    const result = await this.formModalRef.open(baseParams);
    // reset the params
    this.params = null;

    if (result.ok) {
      return new CreateDocumentAssociationsDialogResult({
        ok: true,
        // Set other properties based on your form data
      });
    }
    return new CreateDocumentAssociationsDialogResult({ ok: false });
  }
}
